// Lightweight error boundary stub — the original ErrorBoundary wasn't ported.
// Used only as a wrapper in the payroll pages; falls back to children on success.

import React from "react";

interface Props { children: React.ReactNode; fallback?: React.ReactNode }
interface State { hasError: boolean; error: Error | null }

export class ErrorBoundary extends React.Component<Props, State> {
  state: State = { hasError: false, error: null };
  static getDerivedStateFromError(error: Error): State { return { hasError: true, error }; }
  componentDidCatch(error: Error, info: React.ErrorInfo) {
    console.error("[payroll boundary]", error, info);
  }
  render() {
    if (this.state.hasError) {
      return this.props.fallback ?? (
        <div className="card p-6">
          <div className="text-base font-semibold text-rose-700">Something went wrong</div>
          <div className="mt-1 text-sm text-slate-600">{this.state.error?.message}</div>
          <button className="btn-secondary mt-4" onClick={() => this.setState({ hasError: false, error: null })}>Try again</button>
        </div>
      );
    }
    return this.props.children;
  }
}


export default ErrorBoundary;

